import React from 'react';
import { openInNewTab } from '../../../utils/utils';
import zoomIcon from '../icons/svgs/zoom.svg';
import classes from './ZoomButton.module.css';

const ZoomButton = ({ text, link }) => {
    
    return (
            <button type="button" className={classes.zoomButton} onClick={() => openInNewTab(link)}>
                {text && <span className={classes.zoomText}>{text}</span>}
                <span className={classes.zoomIcon} dangerouslySetInnerHTML={{ __html: zoomIcon }} style={{ display: 'inline-block' }} />
            </button>
    );
};

export default ZoomButton;
